import React from 'react';
import { SvgIcon } from '../svg-icon';

export const Jpg = props => (
  <svg
    width="36"
    height="38"
    viewBox="0 0 36 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_2613_7925)">
      <g clipPath="url(#clip0_2613_7925)">
        <rect
          x="1.59961"
          y="0.800049"
          width="32"
          height="32"
          rx="8"
          fill="url(#paint0_linear_2613_7925)"
        />
        <path
          d="M5.75879 16.4004H29.4395C29.894 16.4004 30.2113 16.4007 30.458 16.4209C30.6998 16.4407 30.8391 16.4776 30.9443 16.5312C31.1699 16.6463 31.3538 16.83 31.4688 17.0557C31.5223 17.1609 31.5594 17.3003 31.5791 17.542C31.5992 17.7886 31.5996 18.1054 31.5996 18.5596V20.96C31.5996 22.7587 31.5992 24.0837 31.5137 25.1309C31.4285 26.1733 31.2606 26.9057 30.9453 27.5244C30.3701 28.6532 29.4521 29.5713 28.3232 30.1465C27.7045 30.4617 26.9721 30.6287 25.9297 30.7139C24.8826 30.7994 23.5573 30.7998 21.7588 30.7998H13.4395C11.6408 30.7998 10.3157 30.7994 9.26855 30.7139C8.22608 30.6287 7.49373 30.4617 6.875 30.1465C5.74614 29.5713 4.82817 28.6532 4.25293 27.5244C3.93767 26.9057 3.77072 26.1733 3.68555 25.1309C3.59999 24.0837 3.59961 22.7587 3.59961 20.96V18.5596C3.59961 18.1053 3.59999 17.7886 3.62012 17.542C3.63988 17.3001 3.67684 17.161 3.73047 17.0557C3.84552 16.8299 4.02909 16.6463 4.25488 16.5312C4.3602 16.4776 4.49928 16.4407 4.74121 16.4209C4.98783 16.4008 5.30454 16.4004 5.75879 16.4004Z"
          fill="url(#paint1_linear_2613_7925)"
          stroke="#C335B7"
          strokeWidth="0.8"
        />
        <path
          d="M3.19922 12.6876C3.19922 13.5388 3.19922 13.9643 3.357 14.2928C3.51442 14.6205 3.77872 14.8848 4.10639 15.0422C4.43484 15.2 4.86041 15.2 5.71155 15.2H29.4392C30.3353 15.2 30.7833 15.2 31.1256 15.0256C31.4267 14.8722 31.6714 14.6274 31.8248 14.3263C31.9992 13.9841 31.9992 13.536 31.9992 12.64V12.4355C31.9992 8.54999 31.9992 6.60723 31.1812 5.39194C30.4662 4.32961 29.3563 3.59704 28.0984 3.35715C26.6594 3.08272 24.873 3.84639 21.3003 5.37374L16.0627 7.61279C15.9237 7.67222 15.8542 7.70194 15.7898 7.72783C13.4883 8.65322 10.8593 8.16531 9.0431 6.47571C8.99227 6.42843 8.93805 6.37575 8.82962 6.2704C8.66288 6.10839 8.5795 6.02739 8.52785 5.98137C6.51348 4.1868 3.31881 5.53712 3.20221 8.2324C3.19922 8.30152 3.19922 8.41776 3.19922 8.65025V12.6876Z"
          fill="url(#paint2_linear_2613_7925)"
        />
        <g filter="url(#filter1_di_2613_7925)">
          <path
            d="M12.2028 20.6H13.7278V25.025C13.7257 25.4396 13.6267 25.8021 13.4309 26.1125C13.2351 26.4208 12.9642 26.6604 12.6184 26.8312C12.2746 27.0021 11.8767 27.0875 11.4246 27.0875C11.0246 27.0875 10.6611 27.0177 10.334 26.8781C10.009 26.7385 9.74965 26.5219 9.5559 26.2281C9.36423 25.9344 9.26944 25.5583 9.27152 25.1H10.8121C10.8184 25.2646 10.8496 25.4052 10.9059 25.5219C10.9642 25.6365 11.0444 25.7229 11.1465 25.7812C11.2486 25.8396 11.3705 25.8687 11.5121 25.8687C11.6601 25.8687 11.7851 25.8375 11.8871 25.775C11.9892 25.7104 12.0663 25.6156 12.1184 25.4906C12.1726 25.3656 12.2007 25.2104 12.2028 25.025V20.6ZM14.5889 27V20.6H17.2326C17.7118 20.6 18.1253 20.6937 18.4732 20.8812C18.8232 21.0667 19.093 21.326 19.2826 21.6594C19.4722 21.9906 19.567 22.376 19.567 22.8156C19.567 23.2573 19.4701 23.6437 19.2764 23.975C19.0847 24.3042 18.8107 24.5594 18.4545 24.7406C18.0982 24.9219 17.6753 25.0125 17.1857 25.0125H15.5545V23.7937H16.8982C17.1316 23.7937 17.3264 23.7531 17.4826 23.6719C17.641 23.5906 17.7607 23.4771 17.842 23.3312C17.9232 23.1833 17.9639 23.0115 17.9639 22.8156C17.9639 22.6177 17.9232 22.4469 17.842 22.3031C17.7607 22.1573 17.641 22.0448 17.4826 21.9656C17.3243 21.8865 17.1295 21.8469 16.8982 21.8469H16.1357V27H14.5889ZM24.4195 22.6906C24.3841 22.5594 24.332 22.4437 24.2632 22.3437C24.1945 22.2417 24.1101 22.1552 24.0101 22.0844C23.9101 22.0135 23.7955 21.9604 23.6664 21.925C23.5372 21.8875 23.3955 21.8687 23.2414 21.8687C22.931 21.8687 22.6622 21.9437 22.4351 22.0937C22.2101 22.2437 22.0362 22.4625 21.9132 22.75C21.7903 23.0354 21.7289 23.3823 21.7289 23.7906C21.7289 24.201 21.7882 24.551 21.907 24.8406C22.0257 25.1302 22.1976 25.351 22.4226 25.5031C22.6476 25.6552 22.9205 25.7312 23.2414 25.7312C23.5247 25.7312 23.7643 25.6854 23.9601 25.5937C24.158 25.5 24.308 25.3677 24.4101 25.1969C24.5122 25.026 24.5632 24.825 24.5632 24.5937L24.8507 24.6281H23.2945V23.5H26.0539V24.3469C26.0539 24.9198 25.932 25.4104 25.6882 25.8187C25.4466 26.2271 25.1132 26.5406 24.6882 26.7594C24.2653 26.9781 23.7789 27.0875 23.2289 27.0875C22.6185 27.0875 22.082 26.9552 21.6195 26.6906C21.157 26.426 20.7966 26.049 20.5382 25.5594C20.2799 25.0677 20.1507 24.4844 20.1507 23.8094C20.1507 23.2844 20.2289 22.8187 20.3851 22.4125C20.5414 22.0042 20.7591 21.6583 21.0382 21.375C21.3195 21.0917 21.6445 20.8771 22.0132 20.7312C22.3841 20.5854 22.783 20.5125 23.2101 20.5125C23.581 20.5125 23.9257 20.5656 24.2445 20.6719C24.5653 20.7781 24.8487 20.9281 25.0945 21.1219C25.3424 21.3156 25.5435 21.5458 25.6976 21.8125C25.8518 22.0792 25.9476 22.3719 25.9851 22.6906H24.4195Z"
            fill="url(#paint3_linear_2613_7925)"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <rect
        x="1.99961"
        y="1.20005"
        width="31.2"
        height="31.2"
        rx="7.6"
        stroke="white"
        strokeWidth="0.8"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_2613_7925"
        x="-0.000390768"
        y="4.88162e-05"
        width="35.2"
        height="37.6"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="0.8"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_2613_7925"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7925"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="3.2"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_2613_7925"
        />
        <feOffset dy="3.2" />
        <feGaussianBlur stdDeviation="2.4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_2613_7925"
          result="effect2_dropShadow_2613_7925"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_2613_7925"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_2613_7925"
        x="9.26855"
        y="19.7125"
        width="16.7852"
        height="8.17495"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.764706 0 0 0 0 0.207843 0 0 0 0 0.717647 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7925"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2613_7925"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.8" />
        <feGaussianBlur stdDeviation="0.8" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2613_7925"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2613_7925"
        x1="17.5996"
        y1="0.800049"
        x2="17.5996"
        y2="32.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F1F1F1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2613_7925"
        x1="17.5992"
        y1="16"
        x2="17.5992"
        y2="31.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C335B7" />
        <stop offset="1" stopColor="#DB66D1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2613_7925"
        x1="17.5992"
        y1="0.799952"
        x2="17.5992"
        y2="15.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4F4F4" />
        <stop offset="1" stopColor="#F4F4F4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2613_7925"
        x1="17.7998"
        y1="19.4667"
        x2="17.7998"
        y2="25.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <clipPath id="clip0_2613_7925">
        <rect
          x="1.59961"
          y="0.800049"
          width="32"
          height="32"
          rx="8"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
